module.exports = __webpack_public_path__ + "img/diamond.eb3ac193.png";